import mixpanel from 'mixpanel-browser';

const GLOBAL_INSTANCE_KEY = 'js_plugin';
const GLOBAL_EVENT_BUS = '__mp_events';
const EVENT_READY = 'mixpanel:plugin-ready';

class SharedMixpanel {
  constructor(config = {}) {
    this.token = config.token;
    this.integration_id = config.integration_id;

    this.config = {
      batch_requests: true,
      ignore_dnt: true,
      track_pageview: true,
      opt_out_tracking_persistence_type: 'cookie',
    };

    this.instance = null;
    this.groupRef = null;

    // Ensure event bus exists
    window[GLOBAL_EVENT_BUS] = window[GLOBAL_EVENT_BUS] || new EventTarget();
    this.eventBus = window[GLOBAL_EVENT_BUS];
  }

  createOrWaitForInstance() {
    return new Promise((resolve) => {
      // Reuse if already available
      if (window._mp_instances?.[GLOBAL_INSTANCE_KEY]) {
        return resolve(window._mp_instances[GLOBAL_INSTANCE_KEY]);
      }

      // Listener if created later
      this.eventBus.addEventListener(EVENT_READY, (e) => {
        const inst = window._mp_instances?.[e.detail.name];
        if (inst) resolve(inst);
      });

      // Create if not already created
      if (!window._mp_instances) window._mp_instances = {};

      if (!window._mp_instances[GLOBAL_INSTANCE_KEY]) {
        const instance = mixpanel.init(this.token, this.config, GLOBAL_INSTANCE_KEY);
        window._mp_instances[GLOBAL_INSTANCE_KEY] = instance;

        this.instance = instance;
        this.group(this.integration_id);
        // this.instance.reset();
        // this.identify();

        this.eventBus.dispatchEvent(new CustomEvent(EVENT_READY, {
          detail: { name: GLOBAL_INSTANCE_KEY }
        }));

        resolve(instance);
      }
    });
  }

  identify(integration_id) {
    if (!this.instance || !integration_id) return;
    this.instance.identify(integration_id);
  }

  group(integration_id, props = {}) {
    if (!this.instance || !integration_id) return;

    const groupKey = 'integration_id';
    const existingGroup = this.instance.get_group(groupKey, integration_id);

    if (!existingGroup) {
      this.instance.add_group(groupKey, integration_id);
      const newGroup = this.instance.get_group(groupKey, integration_id);
      this.groupRef = newGroup;
      newGroup.set_once({ integration_id, ...props });
    } else {
      this.groupRef = existingGroup;
      existingGroup.set_once({ integration_id, ...props });
    }
  }

  setGroupProperties(props = {}) {
    if (this.groupRef) {
      this.groupRef.set(props);
    }
  }

  optOutTracking(trackBoo){
    if (!this.instance) return
    this.instance.set_config({ opt_out_tracking_by_default: trackBoo });

    if (trackBoo) {
      this.instance.opt_out_tracking();
    }
  }
}

export default SharedMixpanel;